<template>
  <div class="p-col-12">
    <div class="card">
      <h5>Empresas</h5>
      <router-link to="/empresas/create">
        <Button label="Nuevo" style="width: 10rem" />
      </router-link>
      <DataTable
        :value="items"
        scrollHeight="400px"
        :loading="loading2"
        scrollDirection="both"
        class="p-mt-3"
      >
        <Column field="name" header="Name"></Column>

        <Column field="active" header="Estado" :sortable="true">
          <template #body="{data}">
            <span class="p-column-title">Estado</span>
            <span
              :class="
                'empresa-badge status-' + (data.active ? 'active' : 'inactive')
              "
              >{{ data.active ? 'Activa' : 'Inactiva' }}</span
            >
          </template>
        </Column>

        <Column
          header="Acciones"
          :exportable="false"
          :style="{ width: '200px' }"
          bodyClas="p-ml-auto"
        >
          <template #body="{data}">
            <Button
              icon="pi pi-pencil"
              class="p-button-rounded p-button-success p-mr-2"
              @click="edit(data.id)"
            />
            <Button
              v-if="isAdmin"
              icon="pi pi-trash"
              class="p-button-rounded p-button-warning p-mr-2"
              @click="borrar(data.id)"
            />
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
import { apiGet, apiDelete } from '../../helpers/rest-api';
import { isUserAdmin } from '../../helpers/security';

export default {
  data() {
    return {
      items: [],
      isAdmin: false,
    };
  },
  mounted() {
    this.getAll();
    this.isAdmin = isUserAdmin();
  },

  methods: {
    getAll() {
      apiGet('empresa').then((response) => (this.items = response.data));
    },

    borrar(index) {
      apiDelete('empresa/' + index).then(() => this.getAll());
    },

    edit(index) {
      this.$router.push('/empresas/edit/' + index);
    },
  },
};
</script>

<style scoped lang="scss">
.cursor {
  cursor: pointer;
}

.empresa-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-active {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-inactive {
    background: #ffcdd2;
    color: #c63737;
  }
}
</style>
